"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleChangeNotificationSchema = void 0;
exports.StyleChangeNotificationSchema = {
    "$id": "https://www.redbull.com/schemas/change-notifications/styles.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "StyleChangeNotification",
    "description": "Change notification sent out when a style is changed",
    "type": "object",
    "properties": {
        "action": {
            "description": "The action field contains the operation leading to the style change. For details, see https://api.developers.redbull.com/docs/resource-change-notifications#header-image-image--or-image-gallery-style-changes",
            "type": "string",
            "enum": [
                "UPSERTED",
                "DELETED"
            ]
        },
        "correlationId": {
            "description": "The correlation ID is a unique identifier that is added to incoming request in order to identify the context and is passed to all components that are involved in the transaction flow.",
            "type": "string",
            "pattern": "^[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        },
        "reference": {
            "additionalProperties": false,
            "type": "object",
            "properties": {
                "resourceId": {
                    "description": "The content resource id this style is associated with.",
                    "type": "string",
                    "pattern": "^rrn:content:[0-9a-z-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
                }
            },
            "required": [
                "resourceId"
            ]
        },
        "resources": {
            "description": "The list of stylings affected by the change. This list does NOT contain all styles associated with the resource, but only the ones impacted by the change.",
            "type": "array",
            "items": {
                "$ref": "../styling.schema.json"
            }
        }
    },
    "additionalProperties": false,
    "required": [
        "correlationId",
        "action",
        "reference",
        "resources"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tb2R1bGVzL2NoYW5nZS1ub3RpZmljYXRpb25zL3N0eWxlcy5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSw2QkFBNkIsR0FBRztJQUMzQyxLQUFLLEVBQUUseUVBQXlFO0lBQ2hGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLHlCQUF5QjtJQUNsQyxhQUFhLEVBQUUsc0RBQXNEO0lBQ3JFLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFlBQVksRUFBRTtRQUNaLFFBQVEsRUFBRTtZQUNSLGFBQWEsRUFBRSxnTkFBZ047WUFDL04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLFVBQVU7Z0JBQ1YsU0FBUzthQUNWO1NBQ0Y7UUFDRCxlQUFlLEVBQUU7WUFDZixhQUFhLEVBQUUseUxBQXlMO1lBQ3hNLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFNBQVMsRUFBRSxtREFBbUQ7U0FDL0Q7UUFDRCxXQUFXLEVBQUU7WUFDWCxzQkFBc0IsRUFBRSxLQUFLO1lBQzdCLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFlBQVksRUFBRTtnQkFDWixZQUFZLEVBQUU7b0JBQ1osYUFBYSxFQUFFLHdEQUF3RDtvQkFDdkUsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLFNBQVMsRUFBRSwrRkFBK0Y7aUJBQzNHO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsWUFBWTthQUNiO1NBQ0Y7UUFDRCxXQUFXLEVBQUU7WUFDWCxhQUFhLEVBQUUsNEpBQTRKO1lBQzNLLE1BQU0sRUFBRSxPQUFPO1lBQ2YsT0FBTyxFQUFFO2dCQUNQLE1BQU0sRUFBRSx3QkFBd0I7YUFDakM7U0FDRjtLQUNGO0lBQ0Qsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixVQUFVLEVBQUU7UUFDVixlQUFlO1FBQ2YsUUFBUTtRQUNSLFdBQVc7UUFDWCxXQUFXO0tBQ1o7Q0FDRixDQUFBIn0=